import React from 'react'
import PropTypes from 'prop-types'
import {Text, Button, Flex, useMultiStyleConfig} from '@chakra-ui/react'
import SanitizedHtml from '../../html-sanitizer'

const Suggestions = ({suggestions, closeAndNavigate, onSuggestedCategorySubmit}) => {
    const styles = useMultiStyleConfig('Search', {variant: 'modalSearch'})

    if (!suggestions || suggestions?.length === 0) {
        return null
    }

    return (
        <Flex {...styles.suggestionsContainer} data-testid="suggestions-container">
            {suggestions.map((suggestion, idx) =>
                suggestion ? (
                    <Button
                        width="full"
                        onMouseDown={(e) => {
                            localStorage.setItem('fromISP', true)
                            suggestion.type === 'category'
                                ? onSuggestedCategorySubmit(e, suggestion.name)
                                : closeAndNavigate(suggestion)
                        }}
                        fontSize="md"
                        key={idx}
                        marginTop={0}
                        variant="menu-link"
                        {...styles.suggestionButton}
                    >
                        <SanitizedHtml
                            as={Text}
                            fontWeight="400"
                            {...styles.suggestionText}
                            html={
                                suggestion?.representedProduct?.c_variantIdentifier ||
                                suggestion?.productName ||
                                suggestion?.name
                            }
                            sanitize={true}
                        />
                    </Button>
                ) : null,
            )}
        </Flex>
    )
}

Suggestions.propTypes = {
    suggestions: PropTypes.array,
    closeAndNavigate: PropTypes.func,
    onSuggestedCategorySubmit: PropTypes.func,
}

export default Suggestions
